import { HttpClient } from "@angular/common/http"
import { Injectable } from "@angular/core"
import { Subject } from "rxjs"
import { API_HOST } from "environments/environment"

@Injectable({
    providedIn: 'root'
})
export class ManagementApiService {

    constructor(private http: HttpClient) { }

    // Units
    public getUnits(params: any) {
        return this.http.get(API_HOST + 'management/units?' + new URLSearchParams(params).toString())
    }
    public getUnitById(id: string) {
        return this.http.get(API_HOST + `management/units/${id}`)
    }
    public createUnit(data: any) {
        return this.http.post(API_HOST + 'management/units', data)
    }
    public updateUnit(id: string, data: any) {
        return this.http.put(API_HOST + `management/units/${id}`, data)
    }
    public deleteUnit(id: string) {
        return this.http.delete(API_HOST + `management/units/${id}`)
    }

    // Terms
    public getTerms(params: any) {
        return this.http.get(API_HOST + 'management/terms?' + new URLSearchParams(params).toString())
    }
    public getTermById(id: string) {
        return this.http.get(API_HOST + `management/terms/${id}`)
    }
    public createTerm(data: any) {
        return this.http.post(API_HOST + 'management/terms', data)
    }
    public updateTerm(id: string, data: any) {
        return this.http.put(API_HOST + `management/terms/${id}`, data)
    }
    public deleteTerm(id: string) {
        return this.http.delete(API_HOST + `management/terms/${id}`)
    }

    // Crews
    public getCrews(params: any) {
        return this.http.get(API_HOST + 'management/crews?' + new URLSearchParams(params).toString())
    }
    public getCrewById(id: string) {
        return this.http.get(API_HOST + `management/crews/${id}`)
    }
    public createCrew(data: any) {
        return this.http.post(API_HOST + 'management/crews', data)
    }
    public updateCrew(id: string, data: any) {
        return this.http.put(API_HOST + `management/crews/${id}`, data)
    }
    public deleteCrew(id: string) {
        return this.http.delete(API_HOST + `management/crews/${id}`)
    }

    // Tasks
    public getTasks(params: any) {
        return this.http.get(API_HOST + 'management/tasks?' + new URLSearchParams(params).toString())
    }
    public getTaskById(id: string) {
        return this.http.get(API_HOST + `management/tasks/${id}`)
    }
    public createTask(data: any) {
        return this.http.post(API_HOST + 'management/tasks', data)
    }
    public updateTask(id: string, data: any) {
        return this.http.put(API_HOST + `management/tasks/${id}`, data)
    }
    public deleteTask(id: string) {
        return this.http.delete(API_HOST + `management/tasks/${id}`)
    }
    public getTaskCategories() {
        return this.http.get(API_HOST + 'management/tasks/categories')
    }
    public deleteTaskCategory(category: string) {
        return this.http.delete(API_HOST + `management/tasks/categories/${encodeURIComponent(category)}`)
    }

    // Positions (Labor Rates)
    public getPositions(params: any) {
        return this.http.get(API_HOST + 'management/positions?' + new URLSearchParams(params).toString())
    }
    public getPositionById(id: string) {
        return this.http.get(API_HOST + `management/positions/${id}`)
    }
    public createPosition(data: any) {
        return this.http.post(API_HOST + 'management/positions', data)
    }
    public updatePosition(id: string, data: any) {
        return this.http.put(API_HOST + `management/positions/${id}`, data)
    }
    public deletePosition(id: string) {
        return this.http.delete(API_HOST + `management/positions/${id}`)
    }

    // Resource Employees
    public getResourceEmployees(params: any) {
        return this.http.get(API_HOST + 'management/resource-employees?' + new URLSearchParams(params).toString())
    }
    public getResourceEmployeeById(id: string) {
        return this.http.get(API_HOST + `management/resource-employees/${id}`)
    }
    public createResourceEmployee(data: any) {
        return this.http.post(API_HOST + 'management/resource-employees', data)
    }
    public updateResourceEmployee(id: string, data: any) {
        return this.http.put(API_HOST + `management/resource-employees/${id}`, data)
    }
    public deleteResourceEmployee(id: string) {
        return this.http.delete(API_HOST + `management/resource-employees/${id}`)
    }

    // Resource Equipment
    public getResourceEquipment(params: any) {
        return this.http.get(API_HOST + 'management/resource-equipment?' + new URLSearchParams(params).toString())
    }
    public getResourceEquipmentById(id: string) {
        return this.http.get(API_HOST + `management/resource-equipment/${id}`)
    }
    public createResourceEquipment(data: any) {
        return this.http.post(API_HOST + 'management/resource-equipment', data)
    }
    public updateResourceEquipment(id: string, data: any) {
        return this.http.put(API_HOST + `management/resource-equipment/${id}`, data)
    }
    public uploadResourceEquipmentImage(id: string, formData: FormData) {
        return this.http.post(API_HOST + `management/resource-equipment/${id}/image`, formData)
    }
    public deleteResourceEquipment(id: string) {
        return this.http.delete(API_HOST + `management/resource-equipment/${id}`)
    }

    // Resource Rentals
    public getResourceRentals(params: any) {
        return this.http.get(API_HOST + 'management/resource-rentals?' + new URLSearchParams(params).toString())
    }
    public getResourceRentalById(id: string) {
        return this.http.get(API_HOST + `management/resource-rentals/${id}`)
    }
    public createResourceRental(data: any) {
        return this.http.post(API_HOST + 'management/resource-rentals', data)
    }
    public updateResourceRental(id: string, data: any) {
        return this.http.put(API_HOST + `management/resource-rentals/${id}`, data)
    }
    public deleteResourceRental(id: string) {
        return this.http.delete(API_HOST + `management/resource-rentals/${id}`)
    }

    // Resource Materials
    public getResourceMaterials(params: any) {
        return this.http.get(API_HOST + 'management/resource-materials?' + new URLSearchParams(params).toString())
    }
    public getResourceMaterialById(id: string) {
        return this.http.get(API_HOST + `management/resource-materials/${id}`)
    }
    public createResourceMaterial(data: any) {
        return this.http.post(API_HOST + 'management/resource-materials', data)
    }
    public updateResourceMaterial(id: string, data: any) {
        return this.http.put(API_HOST + `management/resource-materials/${id}`, data)
    }
    public deleteResourceMaterial(id: string) {
        return this.http.delete(API_HOST + `management/resource-materials/${id}`)
    }
    public getResourceMaterialCategories() {
        return this.http.get(API_HOST + 'management/resource-materials/categories')
    }
    public deleteResourceMaterialCategory(category: string) {
        return this.http.delete(API_HOST + `management/resource-materials/categories/${encodeURIComponent(category)}`)
    }

    // Company Profile
    public getCompanyProfile() {
        return this.http.get(API_HOST + 'management/company-profile')
    }
    public updateCompanyProfile(data: any) {
        return this.http.put(API_HOST + 'management/company-profile', data)
    }

    // Equipment Documents
    public equipmentDocumentUpdated$ = new Subject<void>();

    public createEquipmentDocument(equipmentId: string, data: any) {
        return this.http.post(API_HOST + `management/resource-equipment/${equipmentId}/documents`, data);
    }
    public updateEquipmentDocument(equipmentId: string, docId: string, data: any) {
        return this.http.put(API_HOST + `management/resource-equipment/${equipmentId}/documents/${docId}`, data);
    }
    public deleteEquipmentDocument(equipmentId: string, docId: string) {
        return this.http.delete(API_HOST + `management/resource-equipment/${equipmentId}/documents/${docId}`);
    }
    public uploadEquipmentDocumentAttachment(equipmentId: string, docId: string, file: File) {
        const formData = new FormData();
        formData.append('file', file);
        return this.http.post(API_HOST + `management/resource-equipment/${equipmentId}/documents/${docId}/attachments`, formData);
    }
    public deleteEquipmentDocumentAttachment(equipmentId: string, docId: string, attachmentIndex: number) {
        return this.http.delete(API_HOST + `management/resource-equipment/${equipmentId}/documents/${docId}/attachments/${attachmentIndex}`);
    }
    public confirmEquipmentDocumentUpdate(equipmentId: string, docId: string) {
        return this.http.put(API_HOST + `management/resource-equipment/${equipmentId}/documents/${docId}/confirm-update`, {});
    }
}
